/**
 * Utility functions for mapping states to badge variants.
 *
 * @module components/ui/badgeUtils
 */

import type { BadgeVariant } from './Badge';

/**
 * Maps disk image states to badge variants
 */
export function getDiskImageStateBadgeVariant(state: string): BadgeVariant {
  switch (state.toLowerCase()) {
    case 'ready':
      return 'success';
    case 'creating':
    case 'pending':
      return 'warning';
    case 'error':
      return 'danger';
    case 'deleting':
      return 'info';
    default:
      return 'neutral';
  }
}

/**
 * Maps sandbox states to badge variants
 */
export function getSandboxStateBadgeVariant(state: string): BadgeVariant {
  switch (state.toLowerCase()) {
    case 'running':
      return 'success';
    case 'starting':
    case 'creating':
    case 'pending':
    case 'stopping':
      return 'warning';
    case 'stopped':
      return 'neutral';
    case 'idle':
      return 'warning';
    case 'error':
      return 'danger';
    case 'deleting':
      return 'info';
    default:
      return 'neutral';
  }
}
